const columns = [
  {
    title: "吃瓜专区",
    links: [
      { text: "今日热评", href: "#hot" },
      { text: "弹幕广场", href: "#barrage" },
      { text: "表情包", href: "#memes" },
      { text: "神梗段子", href: "#jokes" },
    ],
  },
  {
    title: "网友专区",
    links: [
      { text: "网友反应合集", href: "#reactions" },
      { text: "我要投稿", href: "#contact" },
      { text: "吃瓜小问", href: "#faq" },
      { text: "关于我们", href: "#about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/60">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-star-smile-line text-xl"></i>
              </span>
              <span className="heading-font text-xl text-foreground-950">
                明星吃瓜<span className="text-primary-500">·现场</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              热评弹幕、表情包、神梗段子、网友反应合集，一站式吃瓜快乐源泉。理性吃瓜，友善发言。
            </p>
            <div className="mt-5 flex gap-2">
              {["weibo", "youtube", "bilibili", "tiktok"].map((s) => (
                <a
                  key={s}
                  href="#top"
                  aria-label="社交平台"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-600"
                >
                  <i className={`ri-${s}-line`}></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <nav key={col.title}>
              <h3 className="text-sm font-bold text-foreground-900">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.text}>
                    <a
                      href={l.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.text}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 明星吃瓜·现场。本站内容为网友公开反应汇编，仅供娱乐交流。
          </p>
          <p className="text-xs text-foreground-500">
            <a href="#contact" className="hover:text-primary-600">
              商务 / 版权联系
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}